/**
 * shop-merci (React) — confirmation de commande. La page merci n'était pas
 * couverte par les CSS shop globaux (styles auparavant inline dans merci.php) :
 * on reconstitue ici un design tokenisé (aucune valeur magique).
 */
.gas-shop-merci-container {
    max-width: 800px;
    margin: 0 auto;
    padding: var(--gas-space-2xl) var(--gas-space-l);
    text-align: center;
}

.gas-merci-success,
.gas-merci-processing,
.gas-merci-error {
    border-radius: var(--gas-radius-l);
    padding: var(--gas-space-2xl);
    box-shadow: var(--gas-shadow-m);
}

.gas-merci-success {
    background: var(--gas-bg-surface-alt);
}

.gas-merci-processing {
    background: var(--gas-warning-light);
    border: var(--gas-border-width-medium) solid var(--gas-warning);
}

.gas-merci-error {
    background: var(--gas-danger-light);
    border: var(--gas-border-width) solid var(--gas-danger-border);
    color: var(--gas-danger-dark);
}

.gas-success-icon,
.gas-processing-icon {
    width: 80px;
    height: 80px;
    color: var(--gas-text-color-inverse);
    border-radius: var(--gas-radius-full);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: var(--gas-text-3xl);
    margin: 0 auto var(--gas-space-xl);
    font-weight: 700;
}

.gas-success-icon {
    background: var(--gas-success);
}

.gas-processing-icon {
    background: var(--gas-warning);
}

.gas-merci-success h1 {
    color: var(--gas-success-dark);
    margin-bottom: var(--gas-space-s);
    font-size: var(--gas-text-2xl);
}

.gas-shop-order-confirmation {
    font-size: var(--gas-text-l);
    color: var(--gas-text-color-light);
    margin-bottom: var(--gas-space-2xl);
}

.gas-order-summary,
.gas-payment-info,
.gas-next-steps,
.gas-processing-info {
    background: var(--gas-bg-surface);
    border-radius: var(--gas-radius-m);
    padding: var(--gas-space-xl);
    margin: var(--gas-space-xl) 0;
    text-align: left;
    box-shadow: var(--gas-shadow-xs);
}

.gas-order-summary h2 {
    margin: 0 0 var(--gas-space-l) 0;
    color: var(--gas-text-color);
    border-bottom: var(--gas-border-width-medium) solid var(--gas-primary);
    padding-bottom: var(--gas-space-s);
}

.gas-order-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--gas-space-m) 0;
    border-bottom: var(--gas-border-width) solid var(--gas-border-color);
}

.gas-order-item:last-child {
    border-bottom: none;
}

.gas-variant-info,
.gas-quantity {
    color: var(--gas-text-color-light);
    font-size: var(--gas-text-s);
}

.gas-quantity {
    margin-left: var(--gas-space-s);
}

.gas-order-total {
    border-top: var(--gas-border-width-medium) solid var(--gas-border-color-strong);
    padding-top: var(--gas-space-m);
    margin-top: var(--gas-space-m);
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-xs);
    font-size: var(--gas-text-l);
}

.gas-order-total-line {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: var(--gas-space-m);
}

.gas-order-total-line small {
    display: inline-block;
    margin-left: var(--gas-space-2xs);
    color: var(--gas-text-color-light);
}

.gas-order-total-line-discount {
    color: var(--gas-warning-dark);
}

.gas-order-total-line-final {
    padding-top: var(--gas-space-xs);
    border-top: var(--gas-border-width) solid var(--gas-border-color);
    font-size: var(--gas-text-xl);
}

.gas-payment-bulletin {
    border-left: var(--gas-border-width-thick) solid var(--gas-warning);
}

.gas-payment-card,
.gas-payment-free {
    border-left: var(--gas-border-width-thick) solid var(--gas-success);
}

.gas-payment-info h3,
.gas-next-steps h3 {
    margin: 0 0 var(--gas-space-m) 0;
    color: var(--gas-text-color);
}

.gas-payment-details {
    background: var(--gas-bg-surface-alt);
    padding: var(--gas-space-m);
    border-radius: var(--gas-radius-s);
    margin-top: var(--gas-space-m);
}

.gas-next-steps ul,
.gas-processing-info ul {
    list-style: none;
    padding: 0;
    margin-top: var(--gas-space-m);
}

.gas-next-steps li,
.gas-processing-info li {
    padding: var(--gas-space-xs) 0;
    border-bottom: var(--gas-border-width) solid var(--gas-border-color);
}

.gas-next-steps li:last-child {
    border-bottom: none;
}

.gas-product-link,
.gas-next-steps li a {
    color: var(--gas-text-color-link);
    text-decoration: none;
}

.gas-product-link:hover,
.gas-next-steps li a:hover {
    color: var(--gas-text-color-link-hover);
    text-decoration: underline;
}

.gas-merci-actions,
.gas-error-actions,
.gas-processing-actions {
    margin-top: var(--gas-space-xl);
    display: flex;
    gap: var(--gas-space-m);
    justify-content: center;
    flex-wrap: wrap;
}

.gas-action-button {
    padding: var(--gas-space-s) var(--gas-space-l);
    border-radius: var(--gas-radius-s);
    text-decoration: none;
    font-weight: 600;
    display: inline-block;
    border: none;
    cursor: pointer;
}

.gas-button-primary {
    background: var(--gas-success);
    color: var(--gas-text-color-inverse);
}

.gas-button-secondary {
    background: var(--gas-secondary);
    color: var(--gas-text-color-inverse);
}

.gas-merci-processing h1 {
    color: var(--gas-warning-dark);
    margin-bottom: var(--gas-space-l);
}

.gas-merci-processing-hint {
    margin-top: var(--gas-space-m);
}

@media (max-width: 768px) {
    .gas-order-item {
        flex-direction: column;
        gap: var(--gas-space-xs);
        align-items: flex-start;
    }

    .gas-merci-actions,
    .gas-error-actions,
    .gas-processing-actions {
        flex-direction: column;
        align-items: center;
    }
}
